/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilterContactResult } from './FilterContactResult';
import {
    FilterContactResultFromJSON,
    FilterContactResultFromJSONTyped,
    FilterContactResultToJSON,
} from './FilterContactResult';

/**
 * 
 * @export
 * @interface ListContactsByFiltersResponseContent
 */
export interface ListContactsByFiltersResponseContent {
    /**
     * 
     * @type {Array<Array<FilterContactResult>>}
     * @memberof ListContactsByFiltersResponseContent
     */
    results?: Array<Array<FilterContactResult>>;
    /**
     * 
     * @type {number}
     * @memberof ListContactsByFiltersResponseContent
     */
    nextPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ListContactsByFiltersResponseContent
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ListContactsByFiltersResponseContent
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ListContactsByFiltersResponseContent
     */
    totalFailedContacts?: number;
    /**
     * 
     * @type {number}
     * @memberof ListContactsByFiltersResponseContent
     */
    totalCompletedContacts?: number;
}


/**
 * Check if a given object implements the ListContactsByFiltersResponseContent interface.
 */
export function instanceOfListContactsByFiltersResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListContactsByFiltersResponseContentFromJSON(json: any): ListContactsByFiltersResponseContent {
    return ListContactsByFiltersResponseContentFromJSONTyped(json, false);
}

export function ListContactsByFiltersResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListContactsByFiltersResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : json['results'],
        'nextPage': !exists(json, 'nextPage') ? undefined : json['nextPage'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
        'totalFailedContacts': !exists(json, 'totalFailedContacts') ? undefined : json['totalFailedContacts'],
        'totalCompletedContacts': !exists(json, 'totalCompletedContacts') ? undefined : json['totalCompletedContacts'],
    };
}

export function ListContactsByFiltersResponseContentToJSON(value?: ListContactsByFiltersResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results,
        'nextPage': value.nextPage,
        'totalPages': value.totalPages,
        'totalRecords': value.totalRecords,
        'totalFailedContacts': value.totalFailedContacts,
        'totalCompletedContacts': value.totalCompletedContacts,
    };
}

